import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFuriousEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16Zm0-30.5C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24 32 9.5 24 9.5Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M27.79 32.88h-7.58c-1.57 0-2.84-1.28-2.84-2.84a2.85 2.85 0 0 1 2.84-2.84h7.58c1.57 0 2.84 1.28 2.84 2.84 0 1.56-1.27 2.84-2.84 2.84Zm-7.58-4.19a1.34 1.34 0 0 0 0 2.68h7.58a1.34 1.34 0 0 0 0-2.68h-7.58Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M21.06 32.41c-.41 0-.75-.34-.75-.75v-3.24c0-.41.34-.75.75-.75s.75.34.75.75v3.24c0 .41-.34.75-.75.75ZM24 32.41c-.41 0-.75-.34-.75-.75v-3.24c0-.41.34-.75.75-.75s.75.34.75.75v3.24c0 .41-.34.75-.75.75ZM26.94 32.41c-.41 0-.75-.34-.75-.75v-3.24c0-.41.34-.75.75-.75s.75.34.75.75v3.24c0 .41-.33.75-.75.75Z",
    fill: "currentColor"
  }));
}

export { SvgFuriousEmojiSecondary as default };
